import React from 'react';
import { ActionContainerVariant } from './types';

interface Props {
	children: React.ReactNode;
	variant: ActionContainerVariant;
}

const ActionContainer: React.FC<Props> = ({ children, variant }) => {
	return (
		<div className={variant === ActionContainerVariant.ACTIVE ? 'bg-bgFields rounded-[4px] ' : ''}>{children}</div>
	);
};

export default ActionContainer;
